import { render, staticRenderFns } from "./Browser.vue?vue&type=template&id=4875e36e&lang=pug"
import script from "./Browser.vue?vue&type=script&lang=ts"
export * from "./Browser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports